import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { Subscription } from 'rxjs';
import { debounceTime, distinctUntilChanged, skip } from 'rxjs/operators';
import { Router, ActivatedRoute, RouterOutlet } from '@angular/router';
import { EventsBrowseService } from '../events-browse.service';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TextFormFieldComponent } from '../../shared/components/inputs/text-form-field/text-form-field.component';
import { SelectFormFieldComponent } from '../../shared/components/inputs/select-form-field/select-form-field.component';

@Component({
  selector: 'app-events-browse',
  templateUrl: './events-browse.component.html',
  styleUrls: ['./events-browse.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    TextFormFieldComponent,
    SelectFormFieldComponent,
    RouterOutlet,
  ],
})
export class EventsBrowseComponent implements OnInit, OnDestroy {
  eventsBrowseService = inject(EventsBrowseService);
  private router = inject(Router);
  private activatedRoute = inject(ActivatedRoute);

  private formSubscription: Subscription;
  public oldWidget: boolean;

  constructor() {
    this.oldWidget = this.router.url.startsWith('/w/');
  }

  ngOnInit() {

    const searchQuery = this.activatedRoute.snapshot.queryParamMap.get('search') || '';

    this.eventsBrowseService.browseModel = {
      ...this.eventsBrowseService.browseModel,
      searchQuery,
    };

    this.formSubscription = this.eventsBrowseService.browseForm.valueChanges.pipe(
      debounceTime(300),
      skip(1),
      distinctUntilChanged(),
    ).subscribe( (search) => {
      this.router.navigate(
        [ search.displayStyle ?? 'list' ],
        {
          relativeTo: this.activatedRoute,
          queryParams: {
            search: search.searchQuery ? search.searchQuery : null,
          },
          queryParamsHandling: 'merge',
        },
      );
    });
  }

  ngOnDestroy() {
    this.formSubscription.unsubscribe();
  }

}
